"use client"

import { ComponentProps } from "react"
import { Toaster as Sonner } from "sonner"
import Spinner from "../../ui/utils/Spinner"

type ToasterProps = ComponentProps<typeof Sonner>

const Toaster = ({ ...props }: ToasterProps) => {

  return (
    <Sonner
      className="toaster group"
      richColors={ false }
      theme="dark"
      closeButton={ true }
      dir="rtl"
      icons={ { "loading": <Spinner /> } }
      pauseWhenPageIsHidden={ true }
      toastOptions={
        {
          classNames: {
            loading: "bg-black/50 backdrop-blur-md",
            toast: 'text-lg shadow-lg shadows-2',
            actionButton: 'text-lg ',
            closeButton: 'w-6 h-auto aspect-square [&>svg]:w-4 [&>svg]:h-4 bg-inherit hover:text-black',

            error: 'bg-red-800/50 text-red-50 backdrop-blur-md',
            success: 'text-green-300 bg-green-700/50 backdrop-blur-md',
            warning: 'text-orange-300 bg-orange-700/50 backdrop-blur-md',
            info: 'bg-blue-600/40 backdrop-blur-md',
          }
        }
      }

      { ...props }
    />
  )
}

export { Toaster }
